<template>
    <Transition name="pop">
        <div id="QuitPop" class="pop" v-if="state.show">
            <div class="content">
                <span class="close" @click="state.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>{{ user.cur_team_type == 1 ? `解散` : `退出` }}兄弟会</h1>
                <h3>
                    您确认{{ user.cur_team_type == 1 ? `解散` : `退出`
                    }}<strong>{{ teamname }}</strong
                    >兄弟会？
                </h3>
                <div class="tips" v-if="user.cur_team_type == 1">
                    解散后将无法找回队伍，且队伍内所有成员在
                    24小时内无法加入其他兄弟团。
                </div>
                <div class="tips" v-else>
                    退出后24小时内无法加入其他兄弟团。
                </div>
                <ul>
                    <li @click="state.show = false">取消</li>
                    <li @click="confirmEvent">确认</li>
                </ul>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { reactive, inject } from "vue";
import useStore from "@/store/store";
import { QuitTeam, DisbandTeam } from "@/api";
const { teamname, user } = storeToRefs(useStore());

const getMyInfo = inject("getMyInfo");

const state = reactive({
    show: false
});

// 确定解散
const confirmEvent = async () => {
    if (user.value.cur_team_type == 1) {
        const res = await DisbandTeam();
        if (res) {
            state.show = false;
            getMyInfo();
            return CsGame.alert("兄弟团解散成功！", 1200, "success");
        }
    } else {
        const res = await QuitTeam();
        if (res) {
            state.show = false;
            getMyInfo();
            return CsGame.alert("兄弟团退出成功！", 1200, "success");
        }
    }
};

defineExpose({
    Show: () => {
        state.show = true;
    }
});
</script>

<style lang="scss" scoped>
#QuitPop {
    .content {
        h3 {
            font-size: 18px;
            text-align: center;
            margin-bottom: 10px;
            line-height: 1.6;
            strong {
                color: #42906a;
                font-weight: bold;
                margin: 0px 6px;
            }
        }
        .tips {
            width: 400px;
            margin: 0px auto;
            padding: 10px;
            border: 1px solid #7c241e;
            color: #7c241e;
            font-size: 14px;
        }
        ul {
            display: flex;
            justify-content: center;
            padding-top: 10px;
            li {
                width: 160px;
                text-align: center;
                line-height: 45px;
                height: 45px;
                margin: 0px 10px;
                border-radius: 6px;
                color: #fff;
                cursor: pointer;
                &:nth-of-type(1) {
                    background-color: #808080;
                }
                &:nth-of-type(2) {
                    background: linear-gradient(to bottom, #86362c, #d6584b);
                }
            }
        }
    }
}
</style>
